import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../../../app/store';
import { refundApi } from '../../../../../../services/RefundService';

/**
 * Hook for handling approvals grid navigation
 */
export function useApprovalsNavigation(company: string, center: string) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleRowSelected = useCallback(
    (args: any) => {
      const selectedItem = args.data;
      if (selectedItem?.id) {
        // Invalidate the refund cache to ensure fresh data when switching between refunds
        dispatch(refundApi.util.invalidateTags(['Refund']));

        navigate(
          `/refunds/edit?company=${encodeURIComponent(company)}&center=${encodeURIComponent(center)}&id=${encodeURIComponent(selectedItem.id)}`
        );
      }
    },
    [company, center, dispatch, navigate]
  );

  return { handleRowSelected };
}
